<div class="modal-header panel-heading">
    <h2 class="modal-title">{{ "extensions.confirmModal.title" | translate }}</h2>
    <button type="button" class="close" (click)="onCancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    @if (loading) {
        <p>{{ "labels.loading" | translate }}</p>
    } @else if (review) {
        <h4 class="section-title">{{ "extensions.confirmModal.extensionSummary" | translate }}</h4>
        <div class="summary-grid">
            <div><span class="label">{{ "extensions.form.startDate" | translate }}:</span> {{ review.extension.startDate || '-' }}</div>
            <div><span class="label">{{ "extensions.form.endDate" | translate }}:</span> {{ review.extension.endDate || '-' }}</div>
            <div><span class="label">{{ "extensions.form.purchasePrice" | translate }}:</span> {{ review.extension.purchasePrice || '-' }}</div>
            <div><span class="label">{{ "extensions.form.soldPrice" | translate }}:</span> {{ review.extension.soldPrice || '-' }}</div>
            <div><span class="label">{{ "extensions.form.costPrice" | translate }}:</span> {{ review.extension.costPrice || '-' }}</div>
            <div><span class="label">{{ "extensions.form.margin" | translate }}:</span> {{ review.extension.margin || '-' }}</div>
            <div><span class="label">{{ "extensions.form.weeklyHours" | translate }}:</span> {{ review.extension.weeklyHours || '-' }}</div>
            <div><span class="label">{{ "extensions.form.currency" | translate }}:</span> {{ review.extension.currency || '-' }}</div>
            <div><span class="label">{{ "extensions.form.equipment" | translate }}:</span> {{ review.extension.equipment || '-' }}</div>
            <div><span class="label">{{ "extensions.form.option" | translate }}:</span> {{ review.extension.option ?? '-' }}</div>
        </div>
        @if (review.extension.description) {
            <div class="mt-2"><span class="label">{{ "extensions.form.description" | translate }}:</span> {{ review.extension.description }}</div>
        }

        <h4 class="section-title mt-4">{{ "extensions.confirmModal.contractDetails" | translate }}</h4>
        @for (cd of review.contractDetails; track cd.details.id) {
            <div class="contract-details-block">
                <div class="cd-header">
                    <span class="label">{{ "contractDetails.form.poNumber" | translate }}:</span> {{ cd.details.po || '-' }} &nbsp;|&nbsp;
                    <span class="label">{{ "contractDetails.form.caseNumber" | translate }}:</span> {{ cd.details.caseNumber || '-' }} &nbsp;|&nbsp;
                    <span class="label">{{ "contractDetails.form.budget" | translate }}:</span> {{ cd.details.budget || '-' }}
                </div>
                @if (cd.items.length > 0) {
                    <table class="table table-sm table-bordered mt-2">
                        <thead>
                            <tr>
                                <th>{{ "itemNumbers.form.title" | translate }}</th>
                                <th>{{ "itemNumbers.form.description" | translate }}</th>
                                <th>{{ "itemNumbers.form.hours" | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of cd.items; track item.id) {
                                <tr>
                                    <td>{{ item.title || '-' }}</td>
                                    <td>{{ item.description || '-' }}</td>
                                    <td>{{ item.hours || '-' }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                } @else {
                    <p class="text-muted mt-1">{{ "extensions.confirmModal.noItems" | translate }}</p>
                }
            </div>
        }
        @if (review.contractDetails.length === 0) {
            <p class="text-muted">{{ "extensions.confirmModal.noContractDetails" | translate }}</p>
        }
    }
</div>
<div class="modal-footer">
    <button class="btn btn-primary ml-3" (click)="onConfirm()">{{ "extensions.confirmModal.confirm" | translate }}</button>
    <button class="btn btn-danger ml-3" (click)="onCancel()">{{ "labels.cancel" | translate }}</button>
</div>
